const BILLING_DATE_LINE = { month: "short", day: "numeric", year: "numeric" };

export function parseBillingInstant(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    const ms = value < 1e12 ? value * 1000 : value;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === "string") {
    const t = value.trim();
    if (!t) return null;
    if (/^\d+$/.test(t)) {
      const n = Number(t);
      if (!Number.isFinite(n)) return null;
      const ms = n < 1e12 ? n * 1000 : n;
      const d = new Date(ms);
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(t);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatBillingInstant(value) {
  const d = parseBillingInstant(value);
  if (!d) return "";
  return d.toLocaleDateString("en-CA", BILLING_DATE_LINE);
}

export function formatBillingMonthYear(value) {
  const d = parseBillingInstant(value);
  if (!d) return "";
  return d.toLocaleDateString("en-CA", { month: "short", year: "numeric" });
}

export function renewalPartsFromInstant(value) {
  const d = parseBillingInstant(value);
  if (!d) return [null, null];
  return [
    d.toLocaleDateString("en-CA", { month: "short", day: "numeric" }),
    String(d.getFullYear()),
  ];
}
